<!-- 需要传三个参数，一个是需要展示的数据源，二是绑定访视期，三是要绑定的字段 -->
<template>
   <div class="btn_fiexd">
      <el-upload 
      action="#" 
      multiple
      :show-file-list="false"
      :auto-upload="true" 
      :http-request="upload"
      >
      <el-button  type="primary">{{btn_name}}</el-button>
      </el-upload>
      <div style="width: 300px;margin-top: 20px;">
        <el-progress :stroke-width="10" v-if="progressFlog" :percentage="loadProgress" />
      </div>
      <div class="demoimgs" v-if="arr_obj(images).length > 0">
          <div v-for="(item, index) in arr_obj(images)" :key="index" class="imgs">
            <img v-if="/\.(jpg|jpeg|png|gif|bmp)$/i.test(item.url)" class="img" :src="item.url" alt="非图片类型">
            <img v-else class="img" src="@/assets/img/project.png" alt="非图片类型">
            <p class="icons">
              <!-- 预览大图 -->
              <span v-if="/\.(jpg|jpeg|png|gif|bmp)$/i.test(item.url)"  @click="handlePictureCardPreview(item)">
                <el-icon class="icon"><zoom-in /></el-icon>
              </span>
              <!-- 下载 -->
              <span @click="downloadImage(item)">
                <el-icon class="icon"><Download /></el-icon>
              </span>
              <!-- 删除 -->
              <span @click="handleRemove(item,index)">
                <el-icon class="icon"><Delete /></el-icon>
              </span>
            </p>
          </div>
        
      </div>
    </div>
    <!-- <div class="preview" v-if="dialogVisible">
        <p class="close" @click="dialogVisible = false">X</p>
        <img class="" :src="dialogImageUrl" alt="只支持图片预览" />
    </div> -->
      <!-- 展示预览图 -->
      <DialogPic v-if="dialogVisible" :imgSrc="dialogImageUrl" @close="dialogVisible = false"></DialogPic>
      <!-- <el-dialog class="dialog" :modal="false" v-model="dialogVisible" draggable>
           <img class="imgpic" :src="dialogImageUrl" alt="只支持图片预览" />
      </el-dialog> -->
  </template>
<script setup>
import {ref,reactive,computed} from 'vue'
import { useCommonStore } from '@/stores/common';
import { Delete, Download, Plus,ZoomIn } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import  DialogPic from "./dialogpic.vue"
import  axios from "axios"

let progressFlog = ref(false)
let loadProgress = ref(0)

// 图片上传的接口
const common = useCommonStore()
// const env = env;
const api_host = import.meta.env.VITE_APP_API_HOST;
const props = defineProps({
    data:{},
    type:null,
    name:'',
    btn_name:{
      type:String,
      default:'报告照片上传'
    },
});
// 拿到父级传来的数据
const model = reactive(props.data)
// console.log(model.id,'fields',`${props.type}`,`${props.name}imagesArray`);
// 获取所有的图片，每个文件的值是一个对象，然后放进数组
const images = computed(() => {
  model.fields[`${props.type}`][`${props.name}imagesArray`] ?'' :model.fields[`${props.type}`][`${props.name}imagesArray`]= []
  return model.fields[`${props.type}`][`${props.name}imagesArray`];
});
// console.log(model.fields[`${props.type}`].images,'images');


// --------------------------
// 处理拿到的数据
const arr_obj = (arr)=>{
  const images = []
  arr.forEach((item,index )=> {
    const obj = {}
      obj.name = item
      obj.url =  `${api_host}api/file/get?name=${ item}`
      obj.download = `${api_host}api/file/get?name=${ item}&isZip=false`
      images.push(obj)
  });
  return images
}
const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const disabled = ref(false)

// 上传图片
const upload =async (file)=>{
  // 防止名字重复加唯一标识(加在了后端)
  
    // 判断文件是否存在
    // let upload_not = await common.upload_not(file.file.name)
    // 检查文件是否可以上传
    // if(upload_not.result != "success") {
    //   ElMessage.error(upload_not.msg)
    //   return
    // }
    // if(!upload_not.data.isAllowUpload) {
    //   ElMessage.error(upload_not.msg)
    //   return 
    // }


    let formdata = new FormData()
    formdata.append('file',file.file)
    formdata.append('id',model.id)
    formdata.append('path',`${props.type}.${props.name}imagesArray`)
    progressFlog.value = true

    const upload = async (formdata)=>{
      let uploadPercent = null
      const res = await axios({
        method: 'post',
        url: `${api_host}api/file/upload`,
        data: formdata,
        onUploadProgress: (progressEvent_1) => {
          // 计算上传进度百分比
          uploadPercent = Math.round((progressEvent_1.loaded * 100) / progressEvent_1.total)
          loadProgress.value = uploadPercent
        }
      })
      return res.data
    }
    // 返回的是一个promise对象
    let res = await upload(formdata)
    if(res.result == 'success'){
        model.fields[`${props.type}`][`${props.name}imagesArray`]?.push(res.data.name)
        progressFlog.value = false
        loadProgress.value =0
    }else{
        ElMessage.error(res.msg)
    }
};
  // 预览
const handlePictureCardPreview = (url) => {
    dialogImageUrl.value = url.url
    dialogVisible.value = true
};
    // 下载图片(无压缩)
const downloadImage =async (e)=> {
     // 获取图片对象和画布对象
     const imgUrl = e?.download
     const response = await fetch(imgUrl)
     const blob = await response.blob()
     // 创建下载链接
     const url = window.URL.createObjectURL(blob)
     const link = document.createElement('a')
     link.href = url
     link.download = e?.name
     document.body.appendChild(link)
     link.click()
     document.body.removeChild(link)
     // 释放 Blob URL
     window.URL.revokeObjectURL(url)
};
  //  删除图片
const handleRemove = (e,index)=>{
  // id=${id}&path=${path}&index=${index}

  ElMessageBox.confirm(
    '确定要删除此文件吗？',
    'Warning',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(async () => {
      let pic_del = await common.pic_del(e.name,model.id,`${props.type}.${props.name}imagesArray`,index)
      if (pic_del.result == 'success'){
        model.fields[`${props.type}`][`${props.name}imagesArray`]?.splice(index,1)
      } else{
        ElMessage.error('删除失败！')
      }
    })
};

</script>

<style lang="scss" scoped> 
.demoimgs{
  // position: absolute;
  // left: 0;
    height: 100px;
    padding: 2px;
    display: flex;
    margin-top:30px;
    .imgs{
     
      display: flex;
      flex-direction: column;
      .img{
        width: 96px;
        height: 96px;
      }
      .icons{
        display: none;
        justify-content:space-around;
        width: 96px;
        height: 96px;
        line-height: 96px;
        margin: 0;
        position: absolute;
        z-index:12;
        .icon{
          font-size: 18px;
          color: white;
        }
      }
    }
    .imgs:hover .icons {
        background-color: rgba(0,0, 0, 0.4);
          display: flex;
      }
}
.preview{
  position: relative;
  .close{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 100;
    color: white;
    font-size: 20px;
    cursor: pointer;
  }
  position: fixed;
  inset: 0;
  z-index: 99;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  .img{
    width: 100%;
    height: 100%;
  }
}
.btn_fiexd{
  margin-left:10px;
  margin-top:21px;
}
// :deep(.el-dialog){
//   width: 800px;
//   height: 800px;
// }
.el-dialog{
  width: 800px;
  height: 800px;
  // width: 800px;
  // height: 800px;
  // width: 80%;
  // height: 80%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  .imgpic{
    width: 100%;
    height: 100%;
  }
}
</style>